<template>
  <div class="detail-wrap" style=" overflow-y: scroll;overflow-x: hidden;">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}好评送延保
        </div>
<!--        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>-->
      </div>
      <div>
        <div>
          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box">
            <div class="d-item">
              <div class="title first">
                <b>主信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      申请单号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.applyNo" :readonly="true" clearable />
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      状态
                    </th>
                    <td>
                      <el-select v-model="formData.stat" :disabled="true">
                        <el-option label="待审核" :value="1" />
                        <el-option label="已审核" :value="2" />
                        <el-option label="审核不通过" :value="3" />
                        <el-option label="做废" :value="4" />
                      </el-select>
                    </td>
                    <th>
                      审核备注
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.remark" :readonly="true" clearable />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      微信ID
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.wxId" :readonly="true" clearable />
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      用户档案号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.profileNo" :readonly="true" clearable />
                    </td>
                    <th>用户妮称</th>
                    <td> <el-input type="text" autocomplete="off" v-model="formData.nickName" :readonly="true" clearable />

                    </td>
                  </tr>
                  <tr>
                    <th>创建人</th>
                    <td>{{ formData.createBy }}</td>
                    <th>创建时间</th>
                    <td>{{ formData.createTime }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div class="title first">
                <b>申请内容</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      产品条码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.barcode" :readonly="true" clearable />
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      赠送延保(月)
                    </th>
                    <td>
                      <el-input type="number" autocomplete="off" oninput="if(value<0||value>9999.99)value=0"
                        v-model="formData.goodCommentGift" :readonly="true" clearable />
                    </td>
                  </tr>
               <tr>
                <th>好评图片</th>
                    <td colspan="">
                      <div>
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }" :disabled="true"
                          list-type="picture-card" :file-list="commentPic"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
                    <th>机器图片</th>
                    <td colspan="">
                      <div  >
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn5 }" :disabled="true"
                           list-type="picture-card" :file-list="machinePic"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
               </tr>
                  <tr>
                    <th>订单图片</th>
                    <td colspan="">
                      <div  >
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn1 }" :disabled="true"
                          list-type="picture-card" :file-list="proofPic1"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
                    <th>发票图片</th>
                    <td colspan="">
                      <div  >
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn2 }" :disabled="true"
                          list-type="picture-card" :file-list="proofPic2"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
                    <th>收据图片</th>
                    <td colspan="">
                      <div  >
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn3 }" :disabled="true"
                          list-type="picture-card" :file-list="proofPic3"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList" />
  </div>
</template>
<script>
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue"
import Tinymce from '@/components/Tinymce';
import store from "@/store";
import api from '@/api/projectApi'
import { fetchTree } from "@/api/admin/type_tree";
import { uploadFileFormat, echoFileFormat } from '@/util/uploadFormat';
import DictSelect from "@/components/formItem/dictSelect.vue";

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    type: String,
  },
  components: {
    DictSelect,
    checkSubjectSearch,
    Tinymce,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      isShow: false,
      showAreaDialog: false,

      justShow: false,

      productOptions0: [],
      dialogImageUrlList: [],
      dialogVisible: false,
      uploadFileUrl: api.uploadFileUrl,
      formData: {
        wxId: null,
        goodCommentGift: null,
        lableName: '',
        basCustAddressList: [],
        slProductPackageDTOList: [],
        stat: 1,  // 状态：1制单；2.待确认；3待申诉；5已申诉；7执行考核；9已结算；19取消执行；99关闭
        proofPic1: [],
        proofPic2: [],
        proofPic3: [],
        commentPic: [],
        machinePic: [],
      },
      proofPic1: [],
      proofPic2: [],
      proofPic3: [],
      commentPic: [{url:''}],
      machinePic: [],
      showPhotoList0: [],
      showPhotoList1: [],
      operationDTOList: [],
      brandOptions: [],
      showSitePop: false,
      showProductCategoryDialog: false,
      showOrderPop: false,
      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,
      radio: '1',
      showEdit: false,
      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      dataId: '',
    };
  },
  watch: {
    'formData.adjustAmount': {
      handler(newVal, oldVal) {
        if (this.formData.standardAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.standardAmount': {
      handler(newVal, oldVal) {
        if (this.formData.adjustAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.checkSubjectId': {
      deep: true,
      handler(newVal) {
        this.checkSubjectSelectOne()
      }
    }
  },
  computed: {
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.getData();
  },
  methods: {
    closeImgViewer() {
      this.dialogVisible = false
    },
    handlePictureCardPreview(file) {
      console.log(file,"放大");
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    showPreconditionDialogFunc() {
      if (this.formData.siteId !== '' && this.formData.siteId !== null)
        this.showOrderPop = true
      else
        this.$message.warning('请先选中网点')
    },

    checkSubjectSelectOne() {
      if (this.formData.checkSubjectId) {
        this.$http.post(api.basCheckSubject.getDataUrl, { id: this.formData.checkSubjectId }).then(res => {
          let data = res.data.data
          this.formData.standardAmount = data.standardAmount
          this.formData.feeAttributeName = data.feeAttributeName
          this.formData.feeAttributeId = data.feeAttributeId
          this.formData.isNeedSiteComplain = data.isNeedSiteComplain
        })
        console.log(this.formData)
      } else {
        this.formData.standardAmount = 0
        this.formData.feeAttributeName = null
        this.formData.feeAttributeId = null
        this.formData.isNeedSiteComplain = null
      }
    },
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$mask.open()

        this.$http({
          url: api.wkGoodCommentApply.getDataUrl + this.dataId,
          method: 'get',
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data;
          this.formData = data
          this.showPhoto = false
          if (this.justShow) {
            this.showPhotoList0 = [data.proofAttachment1, data.proofAttachment2, data.proofAttachment3]
          } else {
            this.proofPic1 = echoFileFormat(data.proofPic1)
            this.proofPic2 = echoFileFormat(data.proofPic2)
            this.proofPic3 = echoFileFormat(data.proofPic3)
            this.commentPic[0].url = data.commentPic
            console.log(this.commentPic,"this.commentPic的值");
            this.machinePic = echoFileFormat(data.machinePic)
          }
          this.justShow = this.formData.stat != 2
          this.showPhoto = true
        })
      }
      this.$mask.close()

    },
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            this.$http({
              url: api.slProduct.saveOrUpdateUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success('保存成功')
              this.reload()
              this.$mask.close()
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },

    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      this.upload_btn1 = false
      console.log(res.data.url, "url")
      this.picList1 = [
        { url: res.data.url }
      ]
    },

    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      this.upload_btn2 = false
      console.log(res.data.url, "url")
      this.picList2 = [
        { url: res.data.url }
      ]
    },

    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      this.upload_btn3 = false
      console.log(res.data.url, "url")
      this.picList3 = [
        { url: res.data.url }
      ]
    },
    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      alert("好评图片:"+res.data.url)
      this.upload_btn4 = false
      console.log(res.data.url, "url")
      this.commentPic = [
        { url: res.data.url }
      ]
    },
    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      this.upload_btn5 = false
      console.log(res.data.url, "url")
      this.picList5 = [
        { url: res.data.url }
      ]
    },
  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 60px;
  height: 60px;
  line-height: 70px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 60px;
  height: 60px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
